import imageCompression from 'browser-image-compression';

interface CompressionConfig {
    maxSizeMB: number;
    maxWidthOrHeight: number;
    useWebWorker: boolean;
    fileType: string;
}

const defaultConfig: CompressionConfig = {
    maxSizeMB: 0.8, // Puntiamo a sotto 1MB
    maxWidthOrHeight: 1920,
    useWebWorker: true, // Fondamentale per non bloccare la UI su dispositivi lenti
    fileType: 'image/webp' // Forziamo la conversione in webp
};

export const optimizeImage = async (file: File): Promise<File> => {
    // Limite assoluto per il file originale: 10MB
    const MAX_FILE_SIZE_MB = 10;

    if (file.size / 1024 / 1024 > MAX_FILE_SIZE_MB) {
        throw new Error(`Il file è troppo grande. La dimensione massima consentita prima della compressione è ${MAX_FILE_SIZE_MB}MB.`);
    }

    try {
        // Se il file è già piccolo (minore di defaultConfig.maxSizeMB), non fare nulla per risparmiare risorse e qualità
        if (file.size / 1024 / 1024 < defaultConfig.maxSizeMB) {
            return file;
        }

        // Comprime l'immagine
        const compressedBlob = await imageCompression(file, defaultConfig);

        // Crea un nome file con estensione .webp
        const newFileName = file.name.replace(/\.[^/.]+$/, "") + ".webp";

        // Crea il file webp
        return new File([compressedBlob], newFileName, {
            type: 'image/webp',
            lastModified: Date.now(),
        });

    } catch (error) {
        console.error("Errore durante la compressione:", error);
        // Fallback: restituiamo il file originale se la compressione fallisce
        // per garantire che il servizio funzioni comunque su device estremi
        return file;
    }
};
